import { useQuery } from '@tanstack/react-query';
import { dashboard } from '../lib/api';
import { queryKeys } from './queryKeys';

export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard,
    queryFn: () => dashboard.get(),
  });
}
